import { Box, styled, Typography } from "@mui/material";
import UserDistributionChart from "./user-distribution-chart";

const GridItem = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "12px",
  borderRadius: "8px",
}));

const GridItemSpan1 = styled(GridItem)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  gridColumn: "span 1",
}));

const UserDistributionType = () => {
  return (
    <GridItemSpan1>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
          px: 1,
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight={700}>
            User type distribution
          </Typography>

          <Typography variant="body2" color="text.secondary">
            All users
          </Typography>
        </Box>
      </Box>

      <UserDistributionChart  />
    </GridItemSpan1>
  );
};

export default UserDistributionType;
